import React, { useEffect, useState } from "react";
import { Button } from "../../../components/ui/button";
import { Calendar } from "../../../components/ui/calendar";
import AddManual from "../../../assets/images/illustration.png";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../../../components/ui/sheet";
import { ReactComponent as CalenderIcon } from "../../../assets/svgs/CalendarIcon.svg";
import { format } from "date-fns";
import DoctorSetAvailibilitySheduler from "../../../components/doctor-side-components/doctor-set-availability-sheduler/DoctorSetAvailabilityScheduler";
import { toast } from "../../../hooks/use-toast";
import {
  createOverrideScheduleOfDoctor_api,
  createWeeklyScheduleOfDoctor_api,
  getOverrideScheduleOfDoctor_api,
  getWeeklyScheduleOfDoctor_api,
} from "../../../api/api_calls/schedule_apiCalls";
import { updateDoctor_api } from "../../../api/api_calls/doctor_apiCalls";
import { me_api } from "../../../api/api_calls/auth_apiCalls";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { parse } from "date-fns";
import LoadingSpinner from "../../../components/animations/LoadingSpinner";
import TimezoneSelector from "../../../components/ui/timezone-selector";
import { Label } from "../../../components/ui/label";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../redux/slices/userSlice";

const SetAvailability = () => {
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [weeklySessions, setWeeklySessions] = useState([]);
  const [overrideSessions, setOverrideSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isUpdatingTimezone, setIsUpdatingTimezone] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    setIsLoading(true);
    try {
      await Promise.all([fetchWeeklySchedule(), fetchOverrideSchedule()]);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchWeeklySchedule = async () => {
    try {
      const res = await getWeeklyScheduleOfDoctor_api();
      const daysOfWeek = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ];
      const transformedMap = {};

      res.data.forEach((dayObj) => {
        const { dayOfWeek, sessions } = dayObj;
        const transformedSessions = sessions.map((session) => ({
          startTime:
            session.startTime.length > 5
              ? session.startTime.slice(0, 5)
              : session.startTime,
          endTime:
            session.endTime.length > 5
              ? session.endTime.slice(0, 5)
              : session.endTime,
          slotDuration: session.slotDuration,
        }));
        transformedMap[dayOfWeek.toLowerCase()] = {
          dayOfWeek: dayOfWeek.toLowerCase(),
          isActive: true,
          sessions: transformedSessions,
        };
      });

      const finalArray = daysOfWeek.map((day) => {
        if (transformedMap[day]?.sessions?.length > 0) {
          return transformedMap[day];
        }
        return {
          dayOfWeek: day,
          isActive: false,
          sessions: [],
        };
      });
      setWeeklySessions(finalArray);
    } catch (error) {
      toast({
        description: error.message,
        variant: "destructive",
      });
      console.log("ERROR IN fetchWeeklySchedule  => ", error);
    }
  };
  const fetchOverrideSchedule = async () => {
    try {
      const res = await getOverrideScheduleOfDoctor_api();
      const finalArray = [];
      res.data.forEach((schedule) => {
        const { date, sessions } = schedule;
        const transformedSessions = sessions.map((session) => {
          return {
            startTime:
              session.startTime.length > 5
                ? session.startTime.slice(0, 5)
                : session.startTime,
            endTime:
              session.endTime.length > 5
                ? session.endTime.slice(0, 5)
                : session.endTime,
            slotDuration: session.slotDuration,
          };
        });
        finalArray.push({
          date: date,
          sessions: transformedSessions,
        });
      });
      setOverrideSessions(finalArray);
    } catch (error) {
      toast({
        description: error.message,
        variant: "destructive",
      });
      console.log("ERROR IN fetchOverrideSchedule  => ", error);
    }
  };
  const submitWeeklySchedule = async () => {
    // Check if doctor has timezone set
    if (!user?.timezone) {
      toast({
        description:
          "Please set your timezone first before saving your schedule",
        variant: "destructive",
      });
      return;
    }

    setIsSaving(true);
    try {
      const weeklySchedule = weeklySessions.map((session) => {
        if (session.isActive) {
          return {
            dayOfWeek: session.dayOfWeek,
            sessions: session.sessions,
          };
        } else {
          return {
            dayOfWeek: session.dayOfWeek,
            sessions: [],
          };
        }
      });
      const res = await createWeeklyScheduleOfDoctor_api({
        schedules: weeklySchedule,
      });
      toast({
        description: res.message,
      });
    } catch (error) {
      toast({
        description: error.message,
        variant: "destructive",
      });
      console.log("ERROR IN submitWeeklySchedule  => ", error);
    } finally {
      setIsSaving(false);
    }
  };
  const submitOverrideSchedule = async () => {
    // Check if doctor has timezone set
    if (!user?.timezone) {
      toast({
        description:
          "Please set your timezone first before saving your schedule",
        variant: "destructive",
      });
      return;
    }

    setIsSaving(true);
    try {
      const res = await createOverrideScheduleOfDoctor_api({
        overrideSchedules: overrideSessions,
      });
      toast({
        description: res.message,
      });
    } catch (error) {
      toast({
        description: error.message,
        variant: "destructive",
      });
      console.log("ERROR IN submitOverrideSchedule  => ", error);
    } finally {
      setIsSaving(false);
    }
  };
  const updateWeeklySessions = (dayOfWeek, newSessions, newActive) => {
    setWeeklySessions((prev) =>
      prev.map((day) =>
        day.dayOfWeek === dayOfWeek
          ? {
              ...day,
              sessions: newSessions,
              isActive: newActive !== undefined ? newActive : day.isActive,
            }
          : day,
      ),
    );
  };

  const updateOverrideSessions = (date, newSessions) => {
    setOverrideSessions((prev) =>
      prev.map((session) =>
        session.date === date
          ? {
              ...session,
              sessions: newSessions,
            }
          : session,
      ),
    );
  };

  const updateDoctorTimezone = async (newTimezone) => {
    setIsUpdatingTimezone(true);
    try {
      await updateDoctor_api({
        doctorData: {
          timezone: newTimezone,
        },
      });

      const res = await me_api();
      dispatch(setUser(res.data));

      toast({
        description: "Timezone updated successfully",
        variant: "success",
      });
    } catch (error) {
      toast({
        description: error.message || "Failed to update timezone",
        variant: "destructive",
      });
      console.log("ERROR IN updateDoctorTimezone  => ", error);
    } finally {
      setIsUpdatingTimezone(false);
    }
  };
  const removeOverrideSchedule = (date) => {
    const newSessions = overrideSessions.filter(
      (session) => session.date !== date,
    );
    setOverrideSessions(newSessions);
  };
  const addOverrideSchedule = (date) => {
    setOverrideSessions((prev) => {
      return [
        ...prev,
        {
          date: date,
          sessions: [
            { startTime: "09:00", endTime: "10:00", slotDuration: 15 },
          ],
        },
      ];
    });
  };

  return (
    <div className="flex items-start justify-start flex-col w-full">
      {isLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
      )}

      {isSaving && (
        <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-50">
          <div className="flex flex-col items-center">
            <LoadingSpinner />
            <p className="mt-4 text-primary font-medium">Saving changes...</p>
          </div>
        </div>
      )}

      <h2 className="text-2xl font-bold mb-4 w-full">Set your Availability</h2>

      {/* Doctor Timezone Selector */}
      <div className="w-full mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <div className="mb-3">
          <h3 className="text-lg font-semibold text-blue-900 mb-1">
            Your Timezone
          </h3>
          <p className="text-sm text-blue-700 mb-3">
            Set your timezone once. All your availability times will be based on
            this timezone.
          </p>
          <div className="max-w-md">
            <Label className="text-sm text-gray-600 mb-2 block">Timezone</Label>
            <TimezoneSelector
              value={user?.timezone || ""}
              onValueChange={updateDoctorTimezone}
              placeholder="Select your timezone..."
              disabled={isUpdatingTimezone}
            />
          </div>
        </div>
      </div>

      {isUpdatingTimezone && (
        <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-50">
          <div className="flex flex-col items-center">
            <LoadingSpinner />
            <p className="mt-4 text-primary font-medium">
              Updating timezone...
            </p>
          </div>
        </div>
      )}

      <div className="flex items-end justify-end w-full gap-4">
        {overrideSessions.length !== 0 && (
          <Button variant={"primary"} onClick={() => setIsSheetOpen(true)}>
            <FaPlus />
            Add Manually
          </Button>
        )}

        <Button
          variant={"primary"}
          onClick={() => navigate("/doctor/view-calendar")}
        >
          View Calendar
        </Button>
      </div>

      <div className="flex items-start justify-center gap-4 flex-row w-full">
        <div className="w-6/12 shadow-xl rounded-xl">
          <div className="relative">
            {weeklySessions.map((dayItem) => (
              <DoctorSetAvailibilitySheduler
                key={dayItem.dayOfWeek}
                day={dayItem.dayOfWeek}
                isActive={dayItem.isActive}
                sessions={dayItem.sessions}
                updateWeeklySessions={updateWeeklySessions}
              />
            ))}
          </div>

          <div className="mt-5 flex justify-end items-center p-5 gap-5">
            <Button
              variant="secondary"
              onClick={() => {
                fetchWeeklySchedule();
              }}
              disabled={isLoading || isSaving}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                submitWeeklySchedule();
              }}
              disabled={isLoading || isSaving}
            >
              Save
            </Button>
          </div>
        </div>

        <div className="w-6/12 rounded-xl shadow-xl p-4 min-h-[400px] relative">
          {overrideSessions.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full">
              <img
                alt="Add manually illustration"
                src={AddManual}
                className="w-[209px] h-[209px] mx-auto mb-4"
              />
              <Button variant="primary" onClick={() => setIsSheetOpen(true)}>
                + Add Manually
              </Button>
            </div>
          ) : (
            <div className="space-y-4">
              {overrideSessions.map((overrideItem) => (
                <DoctorSetAvailibilitySheduler
                  key={overrideItem.date}
                  isForDate={true}
                  date={overrideItem.date}
                  sessions={overrideItem.sessions}
                  updateOverrideSessions={updateOverrideSessions}
                  removeOverrideSchedule={removeOverrideSchedule}
                />
              ))}
            </div>
          )}
          <div className="flex justify-end gap-2 pt-4">
            <Button
              variant="secondary"
              onClick={() => {
                fetchOverrideSchedule();
              }}
              disabled={isLoading || isSaving}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                submitOverrideSchedule();
              }}
              disabled={isLoading || isSaving}
            >
              Save
            </Button>
          </div>
          <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
            <SheetContent className="w-[700px] sm:max-w-[700px] max-h-screen flex flex-col overflow-y-auto">
              <SheetHeader>
                <SheetTitle>Set your Availability</SheetTitle>
              </SheetHeader>
              <DateSelectionForm
                addOverrideSchedule={addOverrideSchedule}
                onCancel={() => setIsSheetOpen(false)}
                initialDates={overrideSessions?.map((session) => {
                  return parse(session.date, "yyyy-MM-dd", new Date());
                })}
              />
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </div>
  );
};

const DateSelectionForm = ({ addOverrideSchedule, onCancel, initialDates }) => {
  const [dates, setDates] = useState(
    initialDates?.length > 0 ? [...initialDates] : [],
  );

  const handleNext = () => {
    const initialDateSet = new Set(
      initialDates.map((d) => format(d, "yyyy-MM-dd")),
    );

    dates.forEach((date) => {
      const dateString = format(date, "yyyy-MM-dd");
      if (!initialDateSet.has(dateString)) {
        addOverrideSchedule(dateString);
      }
    });

    onCancel();
  };

  return (
    <div className="flex flex-col h-full">
      <div className="w-full items-center justify-between flex-row flex">
        <span className="text-[16px] font-bold">
          Select Dates{" "}
          <span className="opacity-50 font-normal">
            (you can select up to 5 days at once)
          </span>
        </span>
        <CalenderIcon />
      </div>

      <div className="flex-1 flex flex-col justify-between">
        <Calendar
          mode="multiple"
          selected={dates}
          onSelect={(selected) => {
            setDates([...selected]);
          }}
          className="w-full"
          numberOfMonths={1}
          disabled={[{ before: new Date() }, ...initialDates]}
        />
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleNext}
            disabled={!dates.length}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SetAvailability;
